import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import BlogFilter from './components/BlogFilter';
import BlogGrid from './components/BlogGrid';
import BlogArchive from './components/BlogArchive';
import Footer from '../home/components/Footer';
import { categories } from '../../mocks/blogPosts';

export default function BlogPage() {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <Hero />
      <BlogFilter
        categories={categories}
        selectedCategory={selectedCategory}
        onCategoryChange={setSelectedCategory}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
      />
      
      {/* Main Content */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <BlogGrid 
            selectedCategory={selectedCategory}
            searchQuery={searchQuery}
          />
        </div>
      </section>

      {/* Archive Section */}
      <BlogArchive />
      
      <Footer />
    </div>
  );
}
